export const environment = {
  version: 'dee00832a6f4770cc10e639c824bae615b33d228',
  buildDate: '202610151300',
  environment: 'release-kw42',
  production: false,
  debug: true,
  dash0Enabled: true,
  baseUrl: 'https://develop.jobboard.catch-talents.dev',
  apiBaseUrl: 'https://release-kw42.api.catch-talents.dev',
  apiBaseUrlFallback: 'https://develop.api.catch-talents.dev',
};
